<template>
  <div class="shfw-wrapper" :style="{width:width*0.2994+'px'}">
    <div class="shfw-head">社区生活服务</div>
    <div id="chart-huan">
    </div>
  </div>
</template>

<script>
  var fuwuChart,
      that
  import echarts from 'echarts'

  export default {
    props:{
      height:null,
      width:null,
      fuwuEc:null
    },
    watch :{
      fuwuEc (newValue,oldValue) {
        this.initFuwuEc(newValue)
      }
    },
    computed:{
      no125 () {
        return this.height/0.302>750 || this.width > 1550?true:false
      },
    },
    methods:{
      initFuwuEc (ec) {
        fuwuChart = echarts.init(document.getElementById('chart-huan'));
        let option = {
          tooltip : { //提示框组件
            trigger: 'item', //触发类型(饼状图片就是用这个)
            formatter: "{c}家  {d}%" //提示框浮层内容格式器
          },
          legend: {
            orient : 'vertical',
            data: ec.legend,
            top:10,
            x : 'left',
            left:10,
            textStyle:{    //图例文字的样式
              color:'#3c3c3c',  //文字颜色
              fontSize:16
            },
          },
          grid: {
            show: false,
          },
          series: [{
            name:'生活服务',
            type:'pie', //类型 pie表示饼图
            radius : ['50%', '70%'],//饼图的半径,第一项是内半径,第二项是外半径,内半径为0就是真的饼,不是环形
            center:['60%','50%'],
            label:{
              show:false,
            },
            data:ec.series,
            itemStyle :{
              color: function (params) {//自定义设定柱状颜
                return ec.color[params.dataIndex];
              },
            }
          }]
        }
        if (!this.no125) {
          option.legend.itemHeight = 10
          option.legend.itemWidth = 10
          option.legend.padding = 0
          option.legend.textStyle.fontSize = 10
        }
        fuwuChart.setOption(option);
        //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
        window.addEventListener('resize',this.resizeEc);
      },
      resizeEc () {
        fuwuChart.resize()
        fuwuChart.clear()
        this.initFuwuEc(this.fuwuEc)
      }
    },
    mounted () {
      that = this;
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeEc)
    }
  }
</script>

<style scoped>
  .shfw-wrapper{
    /*width:575px;*/
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 15px;
    color:#444;
  }
  .shfw-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  #chart-huan{
    width: 100%;
    /*width: 575px;*/
    /*height: 260px;*/
    height:92%;
    margin: 0 auto;
  }
</style>
